import React, { Component, Fragment } from "react";
import styles from "../Search.css";
import { Icon, LIB, SortBy } from "../../../constants/consts-types";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { getSuggestions } from "../../../services/service-wp";
import Svg from "../../Svg/Svg";

// export default function SearchInputAndSuggestions({}) {
class SearchInputAndSuggestions extends Component {
  static propTypes = {
    searchOpen: PropTypes.bool.isRequired,
    searchUrl: PropTypes.string.isRequired,
    langCode: PropTypes.string.isRequired,
    isActive: PropTypes.bool,
  };

  static defaultProps = {
    isActive: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      searchValue: "",
      suggestions: [],
      suggestionFocusIndex: -1,
      inputHasFocus: false,
    };

    this.onKeyUp = this.onKeyUp.bind(this);
    this.onSearchInputFocus = this.onSearchInputFocus.bind(this);
    this.onSearchInputBlur = this.onSearchInputBlur.bind(this);
    this.onButtonSubmit = this.onButtonSubmit.bind(this);
    this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
    this.handleSuggestions = this.handleSuggestions.bind(this);
    this.handleSuggestionFocus = this.handleSuggestionFocus.bind(this);
    this.executeSearch = this.executeSearch.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.searchOpen && this.props.searchOpen) {
      window.addEventListener("keyup", this.onKeyUp);

      setTimeout(() => {
        if (this.nodeInput) {
          this.nodeInput.focus();
        }
      }, 250);
    }

    if (prevProps.searchOpen && !this.props.searchOpen) {
      if (this.nodeInput) {
        this.nodeInput.blur();
      }
      window.removeEventListener("keyup", this.onKeyUp);
    }
  }

  onSearchInputFocus() {
    this.setState({
      inputHasFocus: true,
    });
  }

  onSearchInputBlur() {
    this.setState({
      inputHasFocus: false,
    });
  }

  onKeyUp(event) {
    switch (event.key) {
      case "Enter":
        if (this.state.inputHasFocus)
          this.executeSearch(this.state.searchValue);
        break;
      case "Up":
      case "ArrowUp":
        this.handleSuggestionFocus(-1);
        break;
      case "Down":
      case "ArrowDown":
        this.handleSuggestionFocus(1);
        break;
      default:
        break;
    }
  }

  onButtonSubmit() {
    this.executeSearch(this.state.searchValue);
  }

  handleSuggestionFocus(direction) {
    if (!this.nodeSuggestionsList) return;
    const suggestions = [...this.nodeSuggestionsList.querySelectorAll("li")];
    const numSuggestions = suggestions.length;

    let nextIndex = this.state.suggestionFocusIndex + direction;
    if (direction < 0) {
      // up:
      if (nextIndex < 0) nextIndex = numSuggestions - 1;
    } else {
      // down:
      if (nextIndex > numSuggestions - 1) nextIndex = 0;
    }

    const suggestion = suggestions[nextIndex];
    if (!suggestion) return;
    const suggestionLink = suggestion.querySelector("a");
    suggestionLink.focus();

    this.setState({
      suggestionFocusIndex: nextIndex,
    });
  }

  handleSearchInputChange(event) {
    this.setState(
      {
        searchValue: event.target.value,
      },
      () => {
        this.handleSuggestions(this.state.searchValue);
      }
    );
  }

  async handleSuggestions(searchStr) {
    const suggestions = await getSuggestions(
      searchStr.toLowerCase(),
      this.props.langCode
    );

    await this.setState({
      suggestions: suggestions,
      suggestionFocusIndex: -1,
    });
  }

  executeSearch(searchString) {
    this.props.history.push(
      `${this.props.searchUrl}?q=${encodeURIComponent(searchString)}&order=${
        SortBy.ASC
      }&offset=0&size=18`
    );
  }

  renderSuggestionItem(idx, suggestion) {
    return (
      <li key={idx}>
        <a href={suggestion.url} className={styles.suggestion}>
          <span className={styles.suggestionTitle}>{suggestion.title}</span>

          <span className={styles.spacer}>|</span>

          <span className={styles.suggestionCategory}>
            {suggestion.category || "-"}
          </span>
        </a>
      </li>
    );
  }

  render() {
    const { isActive } = this.props;
    const { searchValue, suggestions } = this.state;

    if (!isActive) return null;

    return (
      <Fragment>
        <div className={styles.searchContainer}>
          <input
            ref={(node) => (this.nodeInput = node)}
            type="search"
            name="search"
            value={searchValue}
            placeholder={LIB.search}
            // autoComplete="search"
            className={styles.searchInput}
            onChange={this.handleSearchInputChange}
            onFocus={this.onSearchInputFocus}
            onBlur={this.onSearchInputBlur}
          />
          <button
            type="submit"
            name="search-submit"
            onClick={this.onButtonSubmit}
            className={styles.buttonSubmit}
            aria-label={`${LIB.goto} ${LIB.search_result}`}
          >
            <Svg id={Icon.SEARCH} className={styles.searchIcon} />
          </button>
        </div>
        {suggestions && suggestions.length > 0 && (
          <ul
            ref={(node) => (this.nodeSuggestionsList = node)}
            className={styles.searchSuggestions}
          >
            {suggestions.map((suggestion, idx) =>
              this.renderSuggestionItem(idx, suggestion)
            )}
          </ul>
        )}
      </Fragment>
    );
  }
}

export default withRouter(SearchInputAndSuggestions);



// WEBPACK FOOTER //
// ./src/components/Search/Components/SearchInputAndSuggestions.js